import {RootDispatchType, RootStateType} from '../store/store';
import {TypedUseSelectorHook, useDispatch, useSelector} from 'react-redux';

export const useAppSelector: TypedUseSelectorHook<RootStateType> = useSelector
export const useAppDispatch = () => useDispatch<RootDispatchType>()